import { put, call } from "redux-saga/effects";
import * as Api from "../../api";
import * as actions from "../actions";

// eslint-disable-next-line import/prefer-default-export
export function* getAddressListSaga(action) {
  const { postCode } = action;
  if (postCode === "") {
    return true;
  }

  try {
    yield put(actions.postcodeClearError());
    yield put(actions.setLoadingState(true));
    const response = yield call(Api.getAddressList, postCode);

    if (response.status === 200) {
      yield put(actions.storeAddressList(response.data));
    }
  } catch (err) {
    yield put(actions.setError(err));
    yield put(actions.postcodeSetError(err));
  } finally {
    yield put(actions.setLoadingState(false));
  }
  return undefined;
}
